<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import { Xhr } from 'tortilla';

export default {
    props: [
        'communityId',
        'openModal',
    ],
    data() {
        return {
            currentFilter: 'all',
            modalOpen: false,
            images: [],
            residences: [],
            selectedCommunity: '',
            selectedResidence: '',
            loaded: false
        };
    },
    mounted: function() {
        $('.community-gallery-image').on('click', (e)=> {
            e.stopPropagation();
            const params = $(e.currentTarget).data('open-community-modal');
            this.communityModal(params);
        });
        Xhr.get(`/api/media-gallery/community/${this.communityId}`)
        .then((res) => {
            this.images = res.data;
            this.loaded = true;
        });

        //  Xhr.get(`/api/residences`)
        // .then((res) => {
        //     this.residences = res.data;
        // });
    },
    computed: {
        selectedImages() {
            let tagFilter = (images) => {
                if(this.currentFilter === 'all') {
                    return images;
                }
                return images.filter(image => {
                    return image.tags[0].name.toLowerCase() === this.currentFilter;
                })
            }
            let communityFilter = (community, images) => {
                if(!community) {
                    return images;
                }

                return images.filter(image => {
                    for (let index = 0; index < image.residences.length; index++) {
                        const element = image.residences[index];
                        if(element.community_id == community) {
                            return true;
                        }
                    }
                    return false;
                })
            }

            let residenceFilter = (residence, images) => {
                if(!residence) {
                    return images;
                }
                return images.filter(image => {
                    for (let index = 0; index < image.residences.length; index++) {
                        const element = image.residences[index];
                        if(element.id == residence) {
                            return true;
                        }
                    }
                    return false;
                })
            }
            let images = tagFilter(this.images);
            images = communityFilter(this.selectedCommunity, images);
            images = residenceFilter(this.selectedResidence, images);

            return images;

        },

        selectedResidences() {
            if(!this.selectedCommunity) {
                return [];
            }
            return this.residences.filter(res => {
                return res.community_id == this.selectedCommunity;
            })
        }
    },
    methods: {
        ...mapActions({
            put: 'slick/put',
            videoPut: 'modal/put'
        }),
        communityModal: function(index, filter) {
            this.$eventsBus.$emit('open-modal', ['modal-community-gallery', { index: index }]);
            this.$nextTick(function() {
                this.put({key: 'modalImageIndex', value: index});
            });
            this.modalOpen = true;
        },
        openVideoModal: function(video) {
            this.$eventsBus.$emit('open-modal', ['modal-video', { video: video }]);
            this.modalOpen = true;
        },
        setFilter(tag) {
            this.currentFilter = tag;
        },
        closeModal () {
            this.modalOpen = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/community-gallery.vue